import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34562427"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"flex","align-items":"center","height":"100%"} }
const _hoisted_2 = { style: {"height":"100%","display":"flex","align-items":"center"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "subapp-container" }, null, -1))

import LayoutToolbar from './components/toolbar/index.vue';
import { RouterTransition } from '@/components/transition/index';
import { computed, toRefs } from 'vue';
import { BaseLayoutMain, BaseLayoutMenuProps } from 'xrk-components';

import { storeToRefs } from 'pinia';
import { RouteLocationNormalizedLoaded, useRoute, useRouter } from 'vue-router';
import appStore from '@/store';
import ProjectCenterEditHeader from '@/views/project-center-edit/src/components/project-center-edit-header.vue';
import { useProject } from './hooks/useProject';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter();
const route = useRoute();

const {
  projectInfo,
  isProjectDetail,
  clearProjectManageStore,
  projectHideMenu
} = useProject();

const _findFirstUrl = menu => {
  if (!menu.menuList?.length) {
    return menu.url;
  } else {
    return _findFirstUrl(menu.menuList[0]);
  }
};
const { onMenuClick, menus, menuUrls } = (() => {
  const { menus, menuUrls } = storeToRefs(appStore.useMenuStoreSetup);

  const onMenuClick = async (menu: BaseLayoutMenuProps['menus'][0]) => {
    // 清除项目中心搜索缓存数据
    if (!isProjectDetail.value) await clearProjectManageStore();

    if (menu.menuList?.length) {
      if (menuType.value === 'horizontal') router.push(_findFirstUrl(menu));
      return;
    }

    router.push(menu.url);
  };

  return { onMenuClick, menus, menuUrls };
})();

// 是否隐藏菜单
const hideMenu = computed(() => {
  // 项目详情，隐藏菜单逻辑特殊处理
  if (isProjectDetail.value) return projectHideMenu();

  return false;
});

// 横向菜单处理
const menuType = computed(() => {
  return menus.value.some(menu => +menu.resourceType === 4)
    ? 'horizontal'
    : 'vertical';
});

// 是否隐藏面包屑
const hideBreadcrumb = computed(() => {
  // 项目详情需要展示面包屑，特殊处理
  if (isProjectDetail.value) return false;

  return menuType.value === 'horizontal';
});

/**
 * @description: 横向菜单，一级菜单处理
 * @returns {*}
 */
const renderMenuTop = () => {
  // 项目中心-编辑项目特殊处理
  if (isProjectDetail.value) return <div></div>;
};

const { menuParentInfo } = toRefs<{ menuParentInfo: Map<string, any> }>(
  appStore.useMenuStoreSetup
);
const breadcrumbFormat = path =>
  (menuParentInfo.value.get?.(path) || []).map(item => {
    return {
      name: item.name,
      ...(menuUrls.value.includes(item.url) && { to: item.url, replace: true })
    };
  });

const findParentPath = (matched: RouteLocationNormalizedLoaded['matched']) => {
  let path = '';
  for (let i = matched.length - 1; i > 0; i--) {
    if (!matched[i].meta.parentPath) {
      path = matched[i].path;
      break;
    }
  }
  return path;
};

const breadcrumbData = computed(() => {
  const { path, meta } = route;
  if (meta.parentPath) {
    // route: 平级情况下不能通过matched遍历出子集，因为list与detail是平级
    const parentPath = (meta.parentPath ??
      findParentPath(route.matched || [])) as string;
    return [...breadcrumbFormat(parentPath), { name: route.meta.title }];
  }
  return breadcrumbFormat(path);
});

return (_ctx: any,_cache: any) => {
  const _component_base_svg = _resolveComponent("base-svg")!

  return (_openBlock(), _createBlock(_unref(BaseLayoutMain), {
    class: _normalizeClass({
      'layout-main': !hideBreadcrumb.value,
      'layout-main-not': hideBreadcrumb.value
    }),
    appName: "营销服务SAAS业务平台",
    menuType: menuType.value,
    hideBreadcrumb: hideBreadcrumb.value,
    menus: _unref(menus),
    breadcrumbData: breadcrumbData.value,
    renderMenuTop: renderMenuTop,
    "hide-menu": hideMenu.value,
    onMenuClick: _unref(onMenuClick)
  }, _createSlots({
    headerLeft: _withCtx(() => [
      _createVNode(_component_base_svg, {
        iconClass: "logo_home",
        style: {"font-size":"200px"}
      })
    ]),
    headerRight: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(LayoutToolbar)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(RouterTransition)),
      _hoisted_3
    ]),
    _: 2
  }, [
    (_unref(isProjectDetail))
      ? {
          name: "bodyTop",
          fn: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(ProjectCenterEditHeader, {
                sceneName: _unref(projectInfo)?.sceneName,
                projectName: _unref(projectInfo)?.projectName,
                projectCode: _unref(projectInfo)?.projectCode
              }, null, 8, ["sceneName", "projectName", "projectCode"])
            ])
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["class", "menuType", "hideBreadcrumb", "menus", "breadcrumbData", "hide-menu", "onMenuClick"]))
}
}

})